export interface StructuredToolPolicyContext {
  taskKind?: 'friend-request-decision' | 'post-comment'
  isGroupChat?: boolean
  callState?: 'idle' | 'incoming' | 'outgoing' | 'active'
}

const CALL_TOOL_NAMES = new Set([
  'initiate_voice_call',
  'initiate_video_call',
  'answer_call',
  'speak_in_call',
  'hang_up_call',
])

const INITIATE_CALL_TOOL_NAMES = new Set(['initiate_voice_call', 'initiate_video_call'])

/** Return a whitelist only when app state requires one. */
export function resolveStructuredToolAllowlist(
  availableToolNames: Iterable<string>,
  context: StructuredToolPolicyContext = {},
): Set<string> | undefined {
  const available = new Set(availableToolNames)
  const onlyAvailable = (names: string[]) => new Set(names.filter(name => available.has(name)))

  if (context.taskKind === 'friend-request-decision')
    return onlyAvailable(['friend_request_response'])

  if (context.taskKind === 'post-comment')
    return onlyAvailable(['comment_on_post', 'silent'])

  if (context.isGroupChat)
    return onlyAvailable(['group_chat_response', 'silent'])

  if (context.callState === 'active')
    return onlyAvailable(['speak_in_call', 'send_messages', 'hang_up_call'])

  if (context.callState === 'incoming')
    return onlyAvailable(['answer_call'])

  if (context.callState === 'outgoing')
    return onlyAvailable(['send_messages', 'silent'])

  if (context.callState === 'idle') {
    return new Set([...available].filter(name =>
      !CALL_TOOL_NAMES.has(name) || INITIATE_CALL_TOOL_NAMES.has(name),
    ))
  }

  return undefined
}

export function filterToolsByStructuredAllowlist<T extends { function?: { name?: string } }>(
  tools: T[],
  allowlist: ReadonlySet<string>,
): T[] {
  return tools.filter(tool => !!tool.function?.name && allowlist.has(tool.function.name))
}
